export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_PAGE_TITLE = "SET_CURRENT_PAGE_TITLE";
export const SET_RESOURCE_TOKEN = "SET_RESOURCE_TOKEN";
export const SET_WEB_SOCKET = "SET_WEB_SOCKET";
export const SET_CURRENT_URL = "SET_CURRENT_URL";
export const SET_SCREEN_SHOT = "SET_SCREEN_SHOT";